import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUICustomizationSettingsDTO } from "../../services/ui-customization-data-service/Models";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UICustomizationSettingsQueryParameters = {
    userID: number;
} & BaseUseQueryParameters<IUICustomizationSettingsDTO | undefined>

export function useUICustomizationSettings({
    userID,
    enabled,
    onError,
    onSuccess
}: UICustomizationSettingsQueryParameters) {
    return useQuery<IUICustomizationSettingsDTO | undefined, RestError>(
        keys.userSettings(userID),
        ({ signal }) => {
            return UICustomizationDataService.getUICustomizationSettings(userID, signal);
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess
        }
    );
}